import { useTranslation } from 'react-i18next';

import { Button } from '@/components/atoms/Buttons';
import { ModalFooter, ModalFooterStart } from '@/components/molecules/ModalComponent';

import { DataSourcesLink } from '../DataSourcesLink';

import { C } from './feedingConfigFields';

import styles from './FeedingConfigPanel.module.scss';

interface Props {
    penScope: boolean;
    saving?: boolean;
    saveError: boolean;
    isValid: boolean;
    /** The site's data sources page; null for no link. */
    dataSourcesHref: string | null;
    onResetPen: () => void;
    onResetToDefaults: () => void;
    onCancel: () => void;
    onSave: () => void;
}

export function FeedingConfigFooter(props: Props) {
    const {
        penScope,
        saving,
        saveError,
        isValid,
        dataSourcesHref,
        onResetPen,
        onResetToDefaults,
        onCancel,
        onSave,
    } = props;
    const { t } = useTranslation();

    return (
        <ModalFooter>
            {/* Site scope resets the FORM to the shipped defaults (still
                    needs saving); pen scope clears the stored overrides, which
                    is a write, so it is a separate action. */}
            <ModalFooterStart>
                {penScope ? (
                    <Button
                        variant="secondary"
                        size="small"
                        type="button"
                        disabled={saving}
                        onClick={onResetPen}>
                        {t(`${C}.scope.resetPen`)}
                    </Button>
                ) : (
                    <Button
                        variant="secondary"
                        size="small"
                        type="button"
                        disabled={saving}
                        onClick={onResetToDefaults}>
                        {t(`${C}.reset`)}
                    </Button>
                )}
                {/* Signal mappings are not settings of this panel; the link says where they are
                    kept. */}
                <DataSourcesLink
                    href={dataSourcesHref}
                    labelKey="providerConfig.entry.siteSettings"
                    standalone
                />
            </ModalFooterStart>
            {saveError ? (
                <span role="alert" className={styles.error}>
                    {t(`${C}.saveError`)}
                </span>
            ) : null}
            <Button
                variant="secondary"
                size="small"
                type="button"
                disabled={saving}
                onClick={onCancel}>
                {t(`${C}.cancel`)}
            </Button>
            <Button
                variant="primary"
                size="small"
                type="button"
                disabled={saving || !isValid}
                onClick={onSave}>
                {t(`${C}.save`)}
            </Button>
        </ModalFooter>
    );
}
